module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sparql-console"
  }, [_c('codemirror', {
    attrs: {
      "id": "codemirror",
      "options": _vm.editorOption
    },
    on: {
      "changes": _vm.onEditorChanges,
      "beforeChange": _vm.onEditorBeforeChange,
      "beforeSelectionChange": _vm.onEditorBeforeSelectionChange
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-fab"
  }, [_c('md-button', {
    staticClass: "md-fab md-primary",
    on: {
      "click": _vm.runQuery
    }
  }, [_c('md-icon', [_vm._v("play_arrow")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dee24e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SparqlConsole.vue
// module id = 156
// module chunks = 1